export const roleOptions = [
  {
    label: "Waiter",
    value: "WAITER",
  },
  {
    label: "Cooker",
    value: "COOK",
  },
  {
    label: "Admin",
    value: "ADMIN",
  },
];
export const currencyOptions = [
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "EUR",
    value: "EUR",
  },
  {
    label: "GBP",
    value: "GBP",
  },
  {
    label: "CNY",
    value: "CNY",
  },
  {
    label: "UAH",
    value: "UAH",
  },
];

export const currencyOptionsMark: Record<string, string> = {
  UAH: "₴",
  USD: "$",
  EUR: "€",
  GBP: "£",
  CNY: "¥",
};